import type { ReactNode } from "react";
import { Box, type BoxProps } from "@mantine/core";

type EcosystemExploreCardFooterProps = {
  children: ReactNode;
} & Pick<BoxProps, "px" | "pb">;

/** Shared bottom footer for expert/corridor explore cards — keeps CTA buttons aligned. */
export default function EcosystemExploreCardFooter({
  children,
  px = "md",
  pb = "md",
}: EcosystemExploreCardFooterProps) {
  return (
    <Box px={px} pb={pb} style={{ flexShrink: 0 }}>
      {children}
    </Box>
  );
}
